import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireSignIn } from '../auth/gate';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { InvitationsPage } from '../screens/invitations/InvitationsPage';

const searchSchema = z.object({
  /** Where the person was going when the invitations were shown; app-relative only. */
  next: z
    .string()
    .regex(/^\/(?!\/)/)
    .optional()
    .catch(undefined),
});

/**
 * The invitations waiting for the person signed in: shown after a sign-in when something waits,
 * linked from the invitation email, and reachable from under their companies while one waits.
 * Signed out, it asks for the sign-in first and comes back.
 */
export const Route = createFileRoute('/invitations')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, location }) => {
    await requireSignIn(context.auth, location.href);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { next } = Route.useSearch();
  return <InvitationsPage next={next} Frame={HushedFrame} />;
}
